import React, { useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

interface Props {
  char: Character;
}

// const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAdvantageButton({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [advantage, setAdvantage] = useState(char.char_interface.body.advantage);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const recalculated = () => {
    setAdvantage(char.char_interface.body.advantage);
    setReloading(true);
  }
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Advantage"
          value={advantage > 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "green", color: "White" }}
          onToggle={() => {
            if (char.body.advantage > 0) {
              char.body.advantage = 0;
            } else {
              char.body.advantage = 1;
            }
            char.changed();
            char.subscription_holder.recalculated();
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ToggleButtonBox 
          name="Disadvantage"
          value={advantage < 0}
          style={{
            height: "16px",
            fontSize: "10px",
            lineHeight: "1.5",
          }}
          colors={{ backgroundColor: "red", color: "White" }}
          onToggle={() => {
            if (char.body.advantage < 0) {
              char.body.advantage = 0;
            } else {
              char.body.advantage = -1;
            }
            char.changed();
            char.subscription_holder.recalculated();
          }}
        />
      </Grid>
    </Grid>
  );
}
